<template>
<div>
  <Header />
  <v-dialog v-model="showLoading" persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        {{message_load ? message_load: "Processing please standby"}}
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-dialog v-model="sending" persistent width="300">
    <v-card color="primary" dark>
      <v-card-title primary-title>
        <div>
          <div class="headline">Sending...</div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-alert :value="true" type="warning">Don't close this window</v-alert>
        <v-progress-linear color="success" v-model="sentPercent"></v-progress-linear>
        <p class="caption">{{ totalSent }} / {{ totalRecipients || 0 }} sent</p>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-container grid-list-md fluid-admin class="container-style">
    <!-- FILTER/SEARCH -->
    <div class="container-header">
      <span>Message Form</span>
    </div>
    <v-tabs centered dark icons-and-text>
      <v-tabs-slider color="blue"></v-tabs-slider>

      <v-tab href="#tab-1">
        Auto
        <v-icon>mdi-message-bulleted</v-icon>
      </v-tab>

      <v-tab href="#tab-2">
        Manual
        <v-icon>mdi-message-plus</v-icon>
      </v-tab>
      <v-tab href="#tab-3">
        Outgoing / Pending
        <v-icon>mdi-mailbox-up</v-icon>
      </v-tab>
      <v-tab href="#tab-4">
        History
        <v-icon>mdi-history</v-icon>
      </v-tab>


      <v-tab-item :value="'tab-1'">
        <v-card flat>
          <v-card-text>
            <v-layout row wrap>
              <v-toolbar flat color="transparent" class="message-info">
                <v-spacer></v-spacer>
                <v-chip label color="white" text-color="teal">
                  <v-icon left>mdi-email-check-outline</v-icon>Sent ({{ messagesSent }})
                </v-chip>
                <v-chip label color="white" text-color="blue">
                  <v-icon left>mdi-email-plus-outline</v-icon>Remaining ({{ messagesLeft }})
                </v-chip>

              </v-toolbar>
              <v-flex xs12>
                <v-select v-model="selectedGradeLevels" :items="gradeLevels" label="Grade Level" box multiple>
                  <template v-slot:prepend-item>
                    <v-list-tile ripple @click="toggle">
                      <v-list-tile-action>
                        <v-icon :color="selectedGradeLevels.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Select All</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12>
                <v-expansion-panel v-if="totalRecipients" class="mb-4">
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <v-flex xs6>
                        Grade Level
                      </v-flex>
                      <v-flex xs6>
                        Recipient Count
                      </v-flex>
                    </template>
                    <v-card>
                      <v-card-actions v-for="data in recipientGradeLevels" class="mx-3">
                        <v-flex xs6>
                          {{ data.level }}
                        </v-flex>
                        <v-flex xs6>
                          {{ data.count }}
                        </v-flex>
                      </v-card-actions>
                      <v-divider light></v-divider>
                      <v-card-actions class="mx-3">
                        <v-flex xs6>
                          Total Recipient
                        </v-flex>
                        <v-flex xs6>
                          {{ totalRecipients }}
                        </v-flex>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="message" box maxlength="480" auto-grow :messages="messageCounter" label="Message">
                </v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <div>
                  <v-toolbar flat color="transparent" class="v-toolbar-button">
                    <v-spacer></v-spacer>
                    <v-btn @click="sendMessage" class="button-style-blue">Send</v-btn>
                  </v-toolbar>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :value="'tab-2'">
        <v-card flat>
          <v-card-text>
            <v-layout>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-toolbar flat color="transparent" class="message-info">
                    <v-spacer></v-spacer>
                    <v-chip label color="white" text-color="teal">
                      <v-icon left>mdi-email-check-outline</v-icon>Sent ({{ messagesSent }})
                    </v-chip>
                    <v-chip label color="white" text-color="blue">
                      <v-icon left>mdi-email-plus-outline</v-icon>Remaining ({{ messagesLeft }})
                    </v-chip>

                  </v-toolbar>
                  <v-flex xs12>
                    <v-combobox v-model="testSendNumbers" :items="testNumbers" hide-selected label="Add Number" multiple box persistent-hint small-chips>
                      <template v-slot:no-data>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              Type a number and press <kbd>enter</kbd> to add recipients
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-combobox>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea v-model="testMessage" box maxlength="480" auto-grow :messages="messageCounter" label="Message">
                    </v-textarea>
                    <div>
                      <v-toolbar flat color="transparent" class="v-toolbar-button">
                        <v-spacer></v-spacer>
                        <v-btn @click="testSendMessage" class="button-style-blue">Send</v-btn>
                      </v-toolbar>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item :value="'tab-3'">
        <v-card flat>
          <v-card-text>
            <v-layout row wrap>
              <v-toolbar flat color="transparent" class="message-info">
                <v-spacer></v-spacer>
                <v-chip label color="white" text-color="teal">
                  <v-icon left>mdi-email-check-outline</v-icon>Sent ({{ messagesSent }})
                </v-chip>
                <v-chip label color="white" text-color="blue">
                  <v-icon left>mdi-email-plus-outline</v-icon>Remaining ({{ messagesLeft }})
                </v-chip>
              </v-toolbar>
              <v-flex xs>
                <template>
                  <v-data-table
                    :headers="headersPending"
                    :items="pending_message"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.number }}</td>
                      <td>{{ props.item.message }}</td>
                      <td>{{ props.item.date }}</td>
                    </template>
                  </v-data-table>
                </template>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>


      <v-tab-item :value="'tab-4'">
        <v-card flat>
          <v-card-text>
            <v-layout row wrap>
              <v-toolbar flat color="transparent" class="message-info">
                <v-spacer></v-spacer>
                <v-chip label color="white" text-color="teal">
                  <v-icon left>mdi-email-check-outline</v-icon>Sent ({{ messagesSent }})
                </v-chip>
                <v-chip label color="white" text-color="blue">
                  <v-icon left>mdi-email-plus-outline</v-icon>Remaining ({{ messagesLeft }})
                </v-chip>
              </v-toolbar>
              <v-flex xs>
                <template>
                  <v-data-table
                    :headers="headersHistory"
                    :items="message_history"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.sender }}</td>
                      <td>{{ props.item.recipient }}</td>
                      <td>{{ props.item.body }}</td>
                      <td>{{ props.item.grade_level }}</td>
                      <td>{{ props.item.send_date }}</td>
                      <td>{{ props.item.status }}</td>
                    </template>
                  </v-data-table>
                </template>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>

    </v-tabs>

  </v-container>
</div>
</template>

<script>
import {
  mapActions,
  mapState
} from "vuex";
import Header from '@/components/Header.vue'
export default {
  name: "MessageForm",
  props: {
    message_load: String,
    specific: Boolean,
  },
  components: {
    Header,
  },
  data() {
    return {
      dialog: false,
      headersPending: [
        {
          value: 'number',
          text: 'Number'
        },
        {
          value: 'message',
          text: 'Message',
          sortable: false,
        },
        {
          value: 'date',
          text: 'Date Sent',
        },
      ],
      headersHistory: [
        {
          value: 'sender',
          text: 'Sender'
        },
        {
          value: 'recipient',
          text: 'Recipient'
        },
        {
          value: 'body',
          text: 'Body',
          sortable: false,
        },
        {
          value: 'grade_level',
          text: 'Grade Level'
        },
        {
          value: 'send_date',
          text: 'Date Sent'
        },
        {
          value: 'status',
          text: 'Status'
        }
      ],
      message_history: [],
      pending_message: [],
      testSendNumbers: [],
      testNumbers: [],
      testMessage: null,
      gradeLevels: [
        {
          value: 1,
          text: 'Nursery'
        },
        {
          value: 2,
          text: 'Kinder 1'
        },
        {
          value: 3,
          text: 'Kinder 2'
        },
        {
          value: 4,
          text: 'Grade 1'
        },
        {
          value: 5,
          text: 'Grade 2'
        },
        {
          value: 6,
          text: 'Grade 3'
        },
        {
          value: 7,
          text: 'Grade 4'
        },
        {
          value: 8,
          text: 'Grade 5'
        },
        {
          value: 9,
          text: 'Grade 6'
        },
        {
          value: 10,
          text: 'Grade 7'
        },
        {
          value: 11,
          text: 'Grade 8'
        },
        {
          value: 12,
          text: 'Grade 9'
        },
        {
          value: 13,
          text: 'Grade 10'
        },
        {
          value: 14,
          text: 'Grade 11'
        },
        {
          value: 15,
          text: 'Grade 12'
        }
      ],
      selectedGradeLevels: [],
      message: null,
      totalRecipients: null,
      recipientGradeLevels: null,
      messagesLeft: null,
      messagesSent: null,
      recipientNumbers: [],
      sending: false,
      totalSent: 0,
    }
  },
  watch: {
    selectedGradeLevels: function(selectedGradeLevels) {
      this.getRecipients({selectedGradeLevels})
        .then((data) => {
          this.totalRecipients = data.total_recipients
          this.recipientGradeLevels = data.grade_levels
          this.recipientNumbers = data.recipient_numbers
        })
        .catch((error) => {})
    }
  },
  computed: {
    ...mapState(['loading']),
    sentPercent() {
      const total = this.totalRecipients || 0
      return ((this.totalSent / total) || 0) * 100
    },
    showLoading() {
      if (this.specific) {
        return this.dialog
      } else {
        return this.loading
      }
    },
    messageCounter() {
      if (this.message != null) {
        const counter = this.message.length
        const messageLength = (counter / 161 | 0) + 1
        const counterText = counter + " chars / " + messageLength + " message (160 characters per message)"
        if (counter == 480) {
          this.$toastr('info', 'Reached maximum characters', '')
        }
        return counterText
      } else {
        return "0 chars / 1 message (160 characters per message)"
      }
    },
    allGradeLevel() {
      return this.selectedGradeLevels.length === this.gradeLevels.length
    },
    notAllGradLevel() {
      return this.selectedGradeLevels.length > 0 && !this.allGradeLevel
    },
    icon() {
      if (this.allGradeLevel) return 'mdi-close-box'
      if (this.notAllGradLevel) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  methods: {
    ...mapActions(["sendBulkMessage", "getRecipients", "getItexMoStatus", "testSendBulkMessage", "getSMSHistory", "getOutgoingMessages"]),
    async sendMessage() {
      if (this.selectedGradeLevels.length > 0 && this.message != null) {
        this.sending = true
        this.totalRecipients = this.recipientNumbers.length
        this.totalSent = 0

        for (const number of this.recipientNumbers) {
          await this.testSendBulkMessage({
            number: number,
            message: this.message
          })
            .then(() => {
              this.totalSent++
            })
            .catch(() => {
              this.totalSent++
              this.$toastr('error', 'Sending Failed ', 'Error')
            })
        }
        this.sending = false
        this.totalRecipients = null
        this.totalSent = 0
        this.initialize()
        this.$toastr('success', 'Sending success!', '')
      } else {
        this.$toastr('error', 'Incomplete Form ', 'Error')
      }



    },
    async testSendMessage() {
      if (this.testSendNumbers.length > 0 && this.testMessage) {
        this.sending = true
        this.totalRecipients = this.testSendNumbers.length
        this.totalSent = 0

        for (const number of this.testSendNumbers) {
          await this.testSendBulkMessage({
            number: number,
            message: this.testMessage
          })
            .then(() => {
              this.totalSent++
            })
            .catch(() => {
              this.totalSent++
              this.$toastr('error', 'Sending Failed ', 'Error')
            })
        }
        this.sending = false
        this.totalRecipients = null
        this.totalSent = 0
        this.initialize()
        this.$toastr('success', 'Sending success!', '')
      } else {
        this.$toastr('error', 'Incomplete Form ', 'Error')
      }
    },
    pendingMessages() {
      this.getOutgoingMessages()
        .then((data) => {
          this.pending_message = data.pending_message
        })
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allGradeLevel) {
          this.selectedGradeLevels = []
        } else {
          this.selectedGradeLevels = this.gradeLevels.map((gradeLevel) => {
            return gradeLevel.value
          })
        }
      })
    },
    initialize() {
      this.selectedGradeLevels = []
      this.message = ''
      this.testMessage = ''
      this.testSendNumbers = []
      this.getItexMoStatus()
        .then((data) => {
          this.messagesLeft = data.messages_left
          this.messagesSent = 1000 - data.messages_left
        })
        .catch((error) => {
          this.$toastr('error', 'Loading status failed', '')
        })
        this.getSMSHistory()
          .then((data) => {
            this.message_history = data.message_history
          })
          .catch((error) => {
            // this.$toastr('error', 'Loading status failed', '')
          })
      this.pendingMessages()
    },
  },
  mounted() {
    this.initialize()
  }
}
</script>
